import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useCallback } from 'react';
import { getInitialValues } from './getInitialValues';
export var useSettigs = function useSettigs(_ref) {
  var groups = _ref.groups,
      getSettings = _ref.getSettings,
      applySetting = _ref.applySetting;

  var _useState = useState(getSettings),
      _useState2 = _slicedToArray(_useState, 2),
      values = _useState2[0],
      setValues = _useState2[1];

  var setValue = useCallback(function (property, value) {
    applySetting(property, value);
    setValues(function (currentValues) {
      return _objectSpread(_objectSpread({}, currentValues), {}, _defineProperty({}, property, value));
    });
  }, [applySetting]);
  var handleRestore = useCallback(function () {
    var initialSettings = getInitialValues(groups);
    Object.keys(initialSettings).forEach(function (property) {
      applySetting(property, initialSettings[property]);
    });
    setValues(initialSettings);
  }, [groups, applySetting]);
  return {
    values: values,
    setValue: setValue,
    handleRestore: handleRestore
  };
};